
import {
  createFeature,
  createReducer,
  on,
} from '@ngrx/store';

import { EnrolleeRecord } from '../../interfaces/enrollee.interface';

import {
  clearCurrentEnrollee,
  loadCurrentEnrollee,
  loadCurrentEnrolleeFailure,
  loadCurrentEnrolleeSuccess,
} from './enrollee.actions';

export interface EnrolleeState {
  enrollmentId: number | null;
  enrollee: EnrolleeRecord | null;
  loading: boolean;
  loaded: boolean;
  error: string | null;
}

export const initialEnrolleeState: EnrolleeState = {
  enrollmentId: null,
  enrollee: null,
  loading: false,
  loaded: false,
  error: null,
};

const reducer = createReducer(
  initialEnrolleeState,

  on(loadCurrentEnrollee, (state) => ({
    ...state,
    loading: true,
    loaded: false,
    error: null,
  })),

  on(
    loadCurrentEnrolleeSuccess,
    (state, { enrollmentId, enrollee }) => ({
      ...state,
      enrollmentId,
      enrollee,
      loading: false,
      loaded: true,
      error: null,
    })
  ),

  on(loadCurrentEnrolleeFailure, (state, { error }) => ({
    ...state,
    loading: false,
    loaded: false,
    error,
  })),

  on(clearCurrentEnrollee, () => initialEnrolleeState)
);

export const enrolleeFeature = createFeature({
  name: 'enrollee',
  reducer,
});